/* ============================================================
   RAEV x Horizon — JavaScript base limpio
   ============================================================ */
(function () {
  'use strict';

  function injectPattern() {
    if (document.querySelector('.raev-pattern-bg')) return;
    var bg = document.createElement('div');
    bg.className = 'raev-pattern-bg';
    bg.setAttribute('aria-hidden', 'true');
    document.body.insertBefore(bg, document.body.firstChild);
  }

  function keepHeaderLogoVisible() {
    document.querySelectorAll('#header-group a.header-logo, #header-component a.header-logo, header a.header-logo').forEach(function (logo) {
      logo.removeAttribute('hidden');
      logo.style.setProperty('opacity', '1', 'important');
      logo.style.setProperty('visibility', 'visible', 'important');
      logo.style.setProperty('pointer-events', 'auto', 'important');
      logo.querySelectorAll('img, svg, picture, .header-logo__image-container').forEach(function (element) {
        element.removeAttribute('hidden');
        element.style.setProperty('opacity', '1', 'important');
        element.style.setProperty('visibility', 'visible', 'important');
      });
    });
  }

  function initHeroLogoScroll() {
    var heroLogo = document.querySelector('.hero .logo-block__image, .hero .logo-block img, .section-hero img, .section-hero .hero__logo, .raev-hero-logo, #hero-logo');
    if (!heroLogo || heroLogo.dataset.raevHeroLogoReady === 'true') return;
    heroLogo.dataset.raevHeroLogoReady = 'true';
    var maxWidth = Math.min(heroLogo.naturalWidth || heroLogo.offsetWidth || 500, window.innerWidth * 0.88);

    function onScroll() {
      var progress = Math.min(Math.max((window.scrollY || document.documentElement.scrollTop || 0) / (window.innerHeight * 0.55), 0), 1);

      keepHeaderLogoVisible();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initSectionFadeIn() {
    if (!('IntersectionObserver' in window) || document.documentElement.dataset.raevFadeReady === 'true') return;
    document.documentElement.dataset.raevFadeReady = 'true';
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.08 });

    document.querySelectorAll('.shopify-section:not(.shopify-section-header):not(.shopify-section-footer)').forEach(function (section, index) {
      if (index === 0) return;
      section.style.opacity = '0';
      section.style.transform = 'translateY(20px)';
      section.style.transition = 'opacity 0.7s ease, transform 0.7s ease';
      observer.observe(section);
    });
  }

  function initCardHover() {
    document.querySelectorAll('.product-card, .card--product').forEach(function (card) {
      if (card.dataset.raevCardHoverReady === 'true') return;
      card.dataset.raevCardHoverReady = 'true';
      card.addEventListener('mouseenter', function () { card.style.borderColor = 'rgba(255,255,255,0.35)'; });
      card.addEventListener('mouseleave', function () { card.style.borderColor = 'rgba(255,255,255,0.12)'; });
    });
  }

  function injectProductPageStyles() {
    if (document.getElementById('raev-product-page-styles')) return;
    var style = document.createElement('style');
    style.id = 'raev-product-page-styles';
    style.textContent = `
      main[data-template^="product"] .raev-product-thumbnails {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.6rem;
        width: 100%;
        margin: 0.8rem auto 0;
        padding: 0.25rem 0 0.45rem;
        overflow-x: auto;
        scrollbar-width: none;
        scroll-snap-type: x proximity;
      }
      main[data-template^="product"] .raev-product-thumbnails::-webkit-scrollbar { display: none; }
      main[data-template^="product"] .raev-product-thumbnail {
        flex: 0 0 60px;
        width: 60px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 3px;
        border: 1px solid rgba(255,255,255,0.16);
        background: transparent;
        opacity: 0.48;
        cursor: pointer;
        scroll-snap-align: center;
        transition: opacity 160ms ease, border-color 160ms ease, transform 160ms ease;
      }
      main[data-template^="product"] .raev-product-thumbnail:hover,
      main[data-template^="product"] .raev-product-thumbnail.is-active {
        opacity: 1;
        border-color: rgba(255,255,255,0.78);
        transform: translateY(-1px);
      }
      main[data-template^="product"] .raev-product-thumbnail img {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: contain;
        object-position: center;
        filter: none;
        mix-blend-mode: normal;
      }
      main[data-template^="product"] media-gallery slideshow-controls:has(.slideshow-controls__counter),
      main[data-template^="product"] media-gallery slideshow-controls:has(.slideshow-controls__dots) {
        display: none !important;
      }
      main[data-template^="product"] .raev-product-drop-copy {
        width: 100%;
        max-width: 46rem;
        color: #fff;
      }
      main[data-template^="product"] .raev-product-drop-copy .raev-drop-kicker {
        margin: 0 0 1.15rem;
        font-family: 'Space Grotesk', sans-serif;
        font-size: 0.65rem;
        line-height: 1.4;
        letter-spacing: 0.3em;
        text-transform: uppercase;
        color: rgba(255,255,255,0.5);
      }
      main[data-template^="product"] .raev-product-drop-copy .raev-drop-specs {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        margin: 0 0 2rem;
        border-top: 1px solid rgba(255,255,255,0.18);
        border-bottom: 1px solid rgba(255,255,255,0.18);
      }
      main[data-template^="product"] .raev-product-drop-copy .raev-drop-spec {
        min-width: 0;
        padding: 1rem 0.9rem;
      }
      main[data-template^="product"] .raev-product-drop-copy .raev-drop-spec:first-child { padding-left: 0; }
      main[data-template^="product"] .raev-product-drop-copy .raev-drop-spec:last-child { padding-right: 0; }
      main[data-template^="product"] .raev-product-drop-copy .raev-drop-spec + .raev-drop-spec {
        border-left: 1px solid rgba(255,255,255,0.14);
      }
      main[data-template^="product"] .raev-product-drop-copy .raev-spec-label {
        margin: 0 0 0.4rem;
        font-family: 'Space Grotesk', sans-serif;
        font-size: 0.62rem;
        letter-spacing: 0.18em;
        text-transform: uppercase;
        color: rgba(255,255,255,0.46);
      }
      main[data-template^="product"] .raev-product-drop-copy .raev-spec-value {
        margin: 0;
        font-family: 'Space Grotesk', sans-serif;
        font-size: 0.88rem;
        line-height: 1.35;
        color: #fff;
      }
      main[data-template^="product"] .raev-product-drop-copy .raev-drop-description {
        font-family: 'Space Grotesk', sans-serif;
        font-size: 0.95rem;
        line-height: 1.72;
        color: rgba(255,255,255,0.78);
      }
      main[data-template^="product"] .raev-product-drop-copy .raev-drop-description p {
        margin: 0 0 1rem;
      }
      main[data-template^="product"] .raev-product-drop-copy .raev-drop-description p:last-child { margin-bottom: 0; }
      @media (max-width: 749px) {
        main[data-template^="product"] .raev-product-thumbnails {
          justify-content: flex-start;
          padding-inline: 0.25rem;
        }
        main[data-template^="product"] .raev-product-thumbnail {
          flex-basis: 56px;
          width: 56px;
          height: 56px;
        }
        main[data-template^="product"] .raev-product-drop-copy .raev-drop-spec {
          padding-inline: 0.65rem;
        }
        main[data-template^="product"] .raev-product-drop-copy .raev-spec-value {
          font-size: 0.78rem;
        }
      }
    `;
    document.head.appendChild(style);
  }

  function initProductThumbnails() {
    var main = document.querySelector('main[data-template^="product"]');
    if (!main) return;

    main.querySelectorAll('media-gallery').forEach(function (gallery) {
      if (gallery.dataset.raevProductThumbsReady === 'true') return;
      var slideshow = gallery.querySelector('slideshow-component');
      if (!slideshow) return;

      var slides = Array.prototype.slice.call(slideshow.querySelectorAll('slideshow-slide')).filter(function (slide) {
        return slide.closest('slideshow-component') === slideshow && slide.querySelector('img');
      });
      if (slides.length < 2) return;

      gallery.dataset.raevProductThumbsReady = 'true';
      var locale = String(document.documentElement.lang || 'es').toLowerCase();
      var viewLabel = locale.indexOf('pt') === 0 ? 'Ver imagem' : locale.indexOf('en') === 0 ? 'View image' : 'Ver imagen';
      var strip = document.createElement('div');
      strip.className = 'raev-product-thumbnails';
      strip.setAttribute('role', 'tablist');
      strip.setAttribute('aria-label', locale.indexOf('pt') === 0 ? 'Miniaturas do produto' : locale.indexOf('en') === 0 ? 'Product thumbnails' : 'Miniaturas del producto');

      var buttons = slides.map(function (slide, index) {
        var sourceImage = slide.querySelector('img');
        var button = document.createElement('button');
        var image = document.createElement('img');
        button.type = 'button';
        button.className = 'raev-product-thumbnail' + (index === 0 ? ' is-active' : '');
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
        button.setAttribute('aria-label', viewLabel + ' ' + (index + 1));
        image.src = sourceImage.currentSrc || sourceImage.src;
        image.alt = '';
        image.loading = 'lazy';
        button.appendChild(image);
        button.addEventListener('click', function (event) {
          if (typeof slideshow.select === 'function') slideshow.select(index, event);
          window.setTimeout(syncActiveThumbnail, 40);
        });
        strip.appendChild(button);
        return button;
      });

      function syncActiveThumbnail() {
        var current = typeof slideshow.current === 'number' ? slideshow.current : 0;
        if (current < 0 || current >= buttons.length) {
          current = slides.findIndex(function (slide) { return slide.getAttribute('aria-hidden') === 'false'; });
          if (current < 0) current = 0;
        }
        buttons.forEach(function (button, index) {
          var active = index === current;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      var observer = new MutationObserver(syncActiveThumbnail);
      slides.forEach(function (slide) {
        observer.observe(slide, { attributes: true, attributeFilter: ['aria-hidden', 'hidden'] });
      });
      slideshow.addEventListener('slideshow:select', syncActiveThumbnail);
      slideshow.insertAdjacentElement('afterend', strip);
      syncActiveThumbnail();
    });
  }

  function init() {
    injectPattern();
    keepHeaderLogoVisible();
    initHeroLogoScroll();
    initSectionFadeIn();
    initCardHover();
    injectProductPageStyles();
    initProductThumbnails();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  window.addEventListener('scroll', keepHeaderLogoVisible, { passive: true });
  window.addEventListener('resize', keepHeaderLogoVisible);
  document.addEventListener('shopify:section:load', init);
})();
